import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Topic Item Routes and Pages
 */
const ListTopicItemPage = React.lazy(() => import("./ListTopicItemPage"));
const AddTopicItemPage = React.lazy(() => import("./AddTopicItemPage.js"));
const EditTopicItemPage = React.lazy(() => import("./EditTopicItemPage"));

const TopicItemRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListTopicItemPage />} />
      <Route exact path="/add" element={<AddTopicItemPage />} />
      <Route exact path="/edit/:id" element={<EditTopicItemPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default TopicItemRoutes;
